import type { UseHttp } from '~/api/interface'

export const clientFetchMessagesById: UseHttp = (params, option) => {
  return useHttp.post(`/api/todayMessagesApi/getMessages/${params?.id}`, undefined, { ...option })
}
